import $ from 'jquery';
import fitVids from 'fitvids';
import _ from 'underscore';
const players = [
    `iframe[src*="fastcompany.com"]`,
    `iframe[src*="fastcodesign.com"]`,
    `iframe[src*="fastcocreate.com"]`,
    `iframe[src*="fastcoexist.com"]`,
    `iframe[src*="fastcompany.local"]`,
    `iframe[src*="fastcodesign.local"]`,
    `iframe[src*="fastcocreate.local"]`,
    `iframe[src*="fastcoexist.local"]`
];

export default function (config) {
    function adjustMediaIframes(conf) {
        let selector = '';
        if (conf !== undefined) {
            selector = conf.fitvidsSelector;
            return fitVids(selector, {
                players
            });
        }
        fitVids('.article-wrapper', {
            players
        });
    }

    function adjustTweetHeight() {
        // 1. Look at all the tweet embed iframes on the page, since we're using relative src, there won't be any cross origin problem.
        // 2. if there's a data attribute for userHeight, use it instead, this is to give editors power even though the height of the tweetbox should be automatically adjusted.
        // 3. If userDefined is not found or is 0, then we process the height by looking through the iframe source's div returned from twitter, then we do some adjustment to that due to margin/paddings set by twitter.
        // 4. Finally set the height of the iframe on our article page to be the optimal height.
        let $el = $('.inline-tweet');
        let retry = 1;
        const MAX_RETRY = 15;

        _.each($el, (val) => {
            if ($el.attr('data-fc-loaded') === true) {
                return;
            }
            var $val = $(val);

            // We don't want to show the ugly scroll bar
            $val.find('iframe').attr('scrolling', 'no');

            // This is set from Drupal bb code, if the user entered height, it will be set here. Else defaults to 0
            let userDefinedHeight = $val.find('iframe').data('userheight');

            if (!userDefinedHeight || userDefinedHeight !== 0) {
                let $twitFrameiFrame = $val.find('iframe');
                $twitFrameiFrame.load(() => {
                    let heightChecker = setInterval(() => {
                        let height = $val.find('iframe').contents().find('iframe').height();
                        // Keep retrying if the height of the returned iframe is < 200, this usually means it returned an invalid height for display.
                        if (_.isNumber(height) && height > 200) {
                            height = height + 30;
                            $val.find('iframe').attr('height', height + 'px');
                            $el.attr('data-fc-loaded', true);
                            clearInterval(heightChecker);
                        } else {
                            retry++;
                            if (retry === MAX_RETRY) {
                                clearInterval(heightChecker);
                            }
                        }
                    }, 500);
                });
            }
        });
    }

    $(document).ready(() => {
        adjustMediaIframes(config);
        adjustTweetHeight();
    });
}
